import {backendService} from "../services/backend.service";
import moment from "moment/moment";

export const GetUserProfile = async () => {
    try {
        return await backendService.userProfile();
    } catch (error) {
        console.error('Error al obtener el perfil del usuario:', error);
        throw error;
    }
};

export const ConvertBlogToFile = async (image) => {
    const name = Array.from({ length: 12 }, () => Math.floor(Math.random() * 10)).join('');
    return await fetch(image)
        .then((r) => r.blob())
        .then(
            (blobFile) => new File(
                [blobFile],
                `${name}.png`,
                {
                    type: "image/png",
                }),
        );
}

export const ValidateIsAdult = (data) => {
    const birthday = moment(data, moment.ISO_8601, true);
    if (!birthday.isValid()) return false;

    const age = moment().diff(birthday, 'years');
    return (age <= 18);
}